import { Alpine } from "alpinejs";
import { alpineData } from "./alpine-data";

export function registerTaskTemplatePrefiller(Alpine: any) {
  Alpine.data("taskTemplatePrefiller", (templates: any[], defaults: any = {}) => alpineData({
    templates: templates,
    title: defaults.title || "",
    description: defaults.description || "",
    taskType: defaults.taskType || "",
    priority: defaults.priority || "normal",
    assignedTo: defaults.assignedTo || "",

    init() {
      // If we have a pre-selected type/priority from NewTaskOptions, they come through defaults
    },

    onTemplateChange(id: string) {
      if (!id) return;
      const tmpl = this.templates.find((t: any) => t.id === id);
      if (tmpl) {
        this.title = tmpl.title || "";
        this.description = tmpl.description || "";
        this.taskType = tmpl.task_type || "";
        this.priority = tmpl.priority || "normal";
        this.assignedTo = tmpl.assigned_to || "";

        // Trigger events for components that might not be using x-model or needs manual refresh
        this.$nextTick(() => {
          // We search within the form or the element this data is attached to
          const root = this.$el;
          root.querySelectorAll("input, select, textarea").forEach((el) => {
            el.dispatchEvent(new Event("input", { bubbles: true }));
            el.dispatchEvent(new Event("change", { bubbles: true }));
          });
        });
      }
    },
  }));
}
